'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/Plus.es.js";
const e = a.forwardRef((r, s) => /* @__PURE__ */ a.createElement(p, { ref: s, ...r, weights: a$1 }));
e.displayName = "PlusIcon";
const n = e;
export {
  n as Plus,
  e as PlusIcon
};
